import { ChangeEvent, Dispatch, FC, FormEvent, SetStateAction, useRef } from 'react';
import { PAYMENT_METHOD_TYPE_ENUM, PaymentMethod } from '../../../../../interfaces';
import { enumToArray, formatStatus } from '../../../../../helpers';
import { Editor } from '@tinymce/tinymce-react';
import { env } from '../../../../../environment';


interface IProps {
  paymentMethod: PaymentMethod;
  onSubmit: (e: FormEvent<HTMLFormElement>, instruction: string) => void;
  onChange: (e: ChangeEvent<HTMLInputElement
    | HTMLSelectElement | HTMLTextAreaElement>) => void;
  setPaymentMethod: Dispatch<SetStateAction<PaymentMethod>>;
  isLoading: boolean;
  loadingText: string;
  submitText: string
}

const PaymentMethodForm: FC<IProps> = (props) => {
  const {
    paymentMethod,
    onSubmit,
    onChange,
    setPaymentMethod,
    isLoading,
    loadingText,
    submitText,
  } = props;
  const editorRef = useRef(null);

  return (
    <section id="paymentMethod-form">
      <form onSubmit={e =>
        //@ts-ignore
        onSubmit(e, editorRef.current?.getContent())}>
        <header><h2>Create New Payment Method</h2></header>
        <div className="row">
          <div className="col-md-4 col-sm-4">
            <div className="form-group">
              <label htmlFor="name">
                Name <span className={"text-danger"}>*</span>
              </label>
              <div className="input-group">
                <input type="text" className="form-control"
                       id="name" name="name"
                       value={paymentMethod.name} onChange={onChange}
                       required/>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-4">
            <div className="form-group">
              <label htmlFor="type">
                Type <span className={"text-danger"}>*</span>
              </label>
              <select name="type" id="type" defaultValue={paymentMethod.type}
                      style={{ width: '100%' }} onChange={onChange}
                      key={Math.random() + '-type'} required>
                {enumToArray(PAYMENT_METHOD_TYPE_ENUM).map((type, i) => (
                  <option key={i} value={type}>{formatStatus(type)}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-4 col-sm-4">
            <div className="form-group">
              <label htmlFor="currency">
                Currency <span className={"text-danger"}>*</span>
              </label>
              <div className="input-group">
                <input type="text" className="form-control"
                       id="currency" name="currency" minLength={3} maxLength={3}
                       value={paymentMethod.currency} onChange={onChange}
                       required/>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="instruction">
                Description <span className={"text-danger"}>*</span>
              </label>
              <Editor
                apiKey={env.tinyMCEAPIKey}
                onInit={(evt, editor) =>
                  //@ts-ignore
                  editorRef.current = editor}
                initialValue={paymentMethod.instruction}
                init={{
                  height: 500,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                    'lists',
                  ],
                  toolbar: 'undo redo | formatselect | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                }}
              />
            </div>
          </div>
          <div className={"col-md-12"}>
            <div className="form-group">
              <button type="submit" className="btn btn-default"
                      disabled={isLoading}>
                {isLoading ? loadingText : submitText}
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
  );
}

export default PaymentMethodForm;